/**
 * Returns extra Tailwind classes to apply on a single photo cell inside a
 * 2-column grid (`grid grid-cols-1 md:grid-cols-2 print:grid-cols-2`).
 *
 * Layout rules:
 *   1 photo            → full width (col-span-2)
 *   3 photos           → first photo full width + 2 below
 *   odd count (≥5)     → first photo full width so the rest pair cleanly
 *   2 / 4 / 6 / 8…     → default 2-per-row
 *
 * Mobile (<md) stays at 1 column always — the span:2 classes only kick in
 * at md+ and on print, which is what the customer/PDF view uses.
 */
export function getPhotoSpanClass(idx, total) {
  if (total === 1) return "md:col-span-2 print:col-span-2";
  if (total >= 3 && total % 2 === 1 && idx === 0) return "md:col-span-2 print:col-span-2";
  return "";
}
